import { Badge, type BadgeTone } from "@/components/ui/badge"
import type { AgentStatus } from "@/types/agent"

// Maps Agent.status → badge tone + display label. Single source of truth
// so any page rendering an agent state picks up the same wording / color.
const STATUS_TONE: Record<AgentStatus, BadgeTone> = {
  live:     "gold",
  training: "warning",
  paused:   "neutral",
  draft:    "neutral",
}

const STATUS_LABEL: Record<AgentStatus, string> = {
  live:     "Live",
  training: "Training",
  paused:   "Paused",
  draft:    "Draft",
}

type Props = { status: AgentStatus }

export function AgentStatusBadge({ status }: Props) {
  return <Badge tone={STATUS_TONE[status]}>{STATUS_LABEL[status]}</Badge>
}
